"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cBrandSettingsSchemaByKey = exports.cBrandImageTypeSchema = exports.cBrandSchema = exports.cCreateBrandReqBodySchema = exports.maxBrandNameLength = exports.minBrandNameLength = void 0;
var zod_1 = require("zod");
exports.minBrandNameLength = 3;
// As defined in the table's schema
exports.maxBrandNameLength = 64;
exports.cCreateBrandReqBodySchema = zod_1.z.object({
    brandName: zod_1.z.string().min(exports.minBrandNameLength).max(exports.maxBrandNameLength)
});
exports.cBrandSchema = exports.cCreateBrandReqBodySchema.and(zod_1.z.object({
    brandId: zod_1.z.number(),
    createdBy: zod_1.z.number(),
    createdAtUtc: zod_1.z.date(),
    lastUpdatedAtUtc: zod_1.z.date(),
}));
exports.cBrandImageTypeSchema = zod_1.z.enum(['favicon', 'logo']);
exports.cBrandSettingsSchemaByKey = {
    logoId: zod_1.z.number(),
    faviconId: zod_1.z.number()
};
